import { ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";

const CTASection = () => {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="synra-section relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl" />
      
      <div className="synra-container relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-8">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm text-primary font-medium">{t("cta.badge")}</span>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            {t("cta.title")}{' '}
            <span className="synra-gradient-text">{t("cta.titleHighlight")}</span>
          </h2>
          
          <p className="text-muted-foreground text-lg mb-10 leading-relaxed">
            {t("cta.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button variant="synra" size="xl" className="group transition-all duration-[250ms] ease-in-out hover:scale-105 hover:shadow-glow-strong" onClick={() => navigate("/auth?tab=partner")}>
              <span>{t("cta.partner")}</span>
              <ArrowRight className={`w-5 h-5 transition-transform duration-200 group-hover:translate-x-1 ${isRTL ? 'rtl-flip' : ''}`} />
            </Button>
            <Button variant="synra-outline" size="xl" className="transition-all duration-[250ms] ease-in-out hover:scale-105 hover:shadow-glow" onClick={() => navigate("/auth?tab=youth")}>
              {t("cta.training")}
            </Button>
          </div>

          <p className="text-muted-foreground text-sm mt-8">
            {t("common.questions")}{' '}
            <a href="mailto:contact@synra.ma" className="text-primary hover:underline">
              contact@synra.ma
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;